const students = [
  {
    path: '/student',
    name: 'student-list',
    component: () => import('@/views/students/school/Student.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'StudentSchool',
    },
  },
  {
    path: '/student-headmaster',
    name: 'student-headmaster-list',
    component: () => import('@/views/students/headmaster/Student.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'StudentHeadMaster',
    },
  },
]
export default students
